import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Util from "../../Util";
import {
  InputCustom,
  SelectCustom,
  Loading,
  HttpError,
} from "../../components";
import * as ApiHelper from "../../ApiHelper";
import { LoadModalWithLabel } from "../modais";
import { ToastContainer, ToastMessage } from "react-toastr";
import InputDinheiroBR from "../../components/InputDinheiroBR";
class GerenciarForm extends Component {
  constructor() {
    super();
    this.calculateItemValue = this.calculateItemValue.bind(this);
    this.getItemDeContratoValue = this.getItemDeContratoValue.bind(this);
    this.getInitialFields = this.getInitialFields.bind(this);
    this.addNota = this.addNota.bind(this);
    this.removeNota = this.removeNota.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.handleErrors = this.handleErrors.bind(this);
    this.calculateValorTotal = this.calculateValorTotal.bind(this);
    this.onChangeDataNota = this.onChangeDataNota.bind(this);
    this.onChangeNumeroNota = this.onChangeNumeroNota.bind(this);
    this.onChangeQuantidadeNota = this.onChangeQuantidadeNota.bind(this);
    this.onChangeItemDeContratoNota =
      this.onChangeItemDeContratoNota.bind(this);
    this.onChangeObservacaoNota = this.onChangeObservacaoNota.bind(this);
    this.toggleLoadModal = this.toggleLoadModal.bind(this);
    this.state = {
      showLoad: false,
      objeto: "",
      itens: [],
      contratoID: "",
      notas: [],
      showForm: false,
      notasError: [],
      valorTotal: 0,
      sumErros: {},
    };
    this.showSucessMessage = this.showSucessMessage.bind(this);
    this.toastFactory = React.createFactory(ToastMessage.animation);
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad,
    });
  }
  showSucessMessage() {
    var message = "Baixas cadastradas com sucesso";
    var title = "Sucesso";
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000,
    });
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000,
      }
    );
  }
  componentWillMount() {
    this.getInitialFields();
  }
  maskMoney(value) {
    if (value) {
      var padded = parseFloat(value).toFixed(2);
      padded = (padded + "").split(".").join(",");
      return "R$ " + padded;
    } else {
      return "R$ 0,00";
    }
  }
  getItemDeContratoValue(id, notaIndex) {
    var itemValue = 0;
    this.state.itens[notaIndex].forEach((item) => {
      if (item.value === parseInt(id, 10)) {
        itemValue = item.valor;
      }
    });
    return itemValue;
  }
  getInitialFields() {
    ApiHelper.getContrato(this.props.match.params.id, (contrato, error) => {
      if (contrato) {
        var oldNotas = this.state.notas;
        var oldItensDeContratos = this.state.itens;
        oldItensDeContratos.push(
          Util.mapItensDeContrato(contrato.itens_de_contratos)
        );
        oldNotas.push({
          numero: "",
          data: "",
          itens: [
            {
              quantidade: "",
              itemDeContrato: "",
              observacao: "",
            },
          ],
          contratoID: contrato.id,
        });
        this.setState(
          {
            notas: oldNotas,
            contratoID: contrato.id,
            objeto: contrato.objeto,
            saldoInicial: contrato.valor_global,
            saldoContratual: contrato.saldo_contratual,
            itens: oldItensDeContratos,
            showForm: true,
          },
          () => {
            window.scrollTo(0, 0);
          }
        );
      } else {
        this.setState({
          httpError: error,
        });
      }
    });
  }
  calculateItemValue(index, notaIndex) {
    var oldNotas = this.state.notas;
    if (
      oldNotas[notaIndex].itens &&
      oldNotas[notaIndex].itens[index].quantidade &&
      oldNotas[notaIndex].itens[index].itemDeContrato
    ) {
      var currentItem = oldNotas[notaIndex].itens[index];
      var itens = oldNotas[notaIndex].itens;
      var itemQuantidade = currentItem.quantidade;
      var itemValorUnitario = this.getItemDeContratoValue(
        currentItem.itemDeContrato,
        notaIndex
      );
      var valorTotalItem = itemQuantidade * itemValorUnitario;
      currentItem.valor = valorTotalItem;
      oldNotas[notaIndex].itens[index] = currentItem;
      var soma = 0;
      itens.forEach((item) => {
        var valor = this.getItemDeContratoValue(item.itemDeContrato, notaIndex);
        var quantidade = item.quantidade;
        soma += valor * quantidade;
      });
      oldNotas[notaIndex].valor = soma;
    } else {
      oldNotas[notaIndex].itens[index].valor = 0.0;
      oldNotas[notaIndex].valor = 0.0;
    }
    this.setState(
      {
        notas: oldNotas,
      },
      () => {
        this.calculateValorTotal();
      }
    );
  }
  onChangeItemDeContratoNota(event, index, notaIndex) {
    var newState = {
      valor_totalError: "",
      sumErros: {},
    };
    if (this.state.notasError[index]) {
      var oldNotasError = this.state.notasError;
      oldNotasError[notaIndex].itens_nota_fiscal[index].itens_de_contrato_id =
        "";
      newState.notasError = oldNotasError;
    }
    var newValue = event.target.value;
    var oldNotas = this.state.notas;
    oldNotas[notaIndex].itens[index].itemDeContrato = newValue;
    newState.notas = oldNotas;
    this.setState(newState, () => {
      this.calculateItemValue(index, notaIndex);
    });
  }
  onChangeObservacaoNota(event, index, notaIndex) {
    var newValue = event.target.value;
    var oldNotas = this.state.notas;
    oldNotas[notaIndex].itens[index].observacao = newValue;
    this.setState({
      notas: oldNotas,
    });
  }
  onChangeQuantidadeNota(event, index, notaIndex, value) {
    var newState = {
      valor_totalError: "",
    };
    var oldNotasError = this.state.notasError;
    if (this.state.notasError[index]) {
      oldNotasError[notaIndex].itens_nota_fiscal[index].quantidade = "";
    }
    var newValue = "";
    var oldNotas = this.state.notas;
    if (oldNotas[notaIndex].itens[index].baixaValor) {
      newValue = value;
      var itemValorUnitario = this.getItemDeContratoValue(
        oldNotas[notaIndex].itens[index].itemDeContrato,
        notaIndex
      );
      var quantidade = newValue / itemValorUnitario;
      oldNotas[notaIndex].itens[index].quantidade = parseFloat(
        quantidade.toFixed(14)
      );
    } else {
      newValue = event.target.value;
      oldNotas[notaIndex].itens[index].quantidade = newValue;
    }
    newState.notas = oldNotas;
    this.setState(newState, () => {
      this.calculateItemValue(index, notaIndex);
    });
  }
  getTodayDateFormatted() {
    var date = new Date();
    var str =
      date.getFullYear() +
      "" +
      "-" +
      (date.getMonth() + "").padStart(2, "0") +
      "-" +
      (date.getDate() + "").padStart(2, "0");
    return str;
  }
  onChangeDataNota(value, index) {
    var newState = {};
    if (this.state.notasError[index]) {
      var oldNotasError = this.state.notasError;
      oldNotasError[index].data = "";
      newState.notasError = oldNotasError;
    }
    var newValue = value;
    var oldNotas = this.state.notas;
    oldNotas[index].data = newValue;
    newState.notas = oldNotas;
    this.toggleLoadModal();
    ApiHelper.getValoresUnitariosByDate(
      newValue ? newValue : this.getTodayDateFormatted(),
      this.state.contratoID,
      (data, error) => {
        this.toggleLoadModal();
        if (error) {
          this.setState({
            httpError: error,
          });
        } else {
          var oldItensDeContratos = this.state.itens;
          oldItensDeContratos[index] = Util.mapItensDeContrato(data);
          this.setState(
            {
              itens: oldItensDeContratos,
            },
            () => {
              this.state.notas[index].itens.forEach((item, key) => {
                this.calculateItemValue(key, index);
              });
            }
          );
        }
      }
    );
    this.setState(newState);
  }
  onChangeBaixaValor(event, index, notaIndex) {
    var newValue = event.target.checked;
    var oldNotas = this.state.notas;
    oldNotas[notaIndex].itens[index].baixaValor = newValue;
    this.setState({ notas: oldNotas });
  }
  onChangeNumeroNota(event, index) {
    var newState = {};
    if (this.state.notasError[index]) {
      var oldNotasError = this.state.notasError;
      oldNotasError[index].numero = "";
      newState.notasError = oldNotasError;
    }
    var newValue = event.target.value;
    var oldNotas = this.state.notas;
    oldNotas[index].numero = newValue;
    newState.notas = oldNotas;
    this.setState(newState);
  }
  addNota(event) {
    event.preventDefault();
    var oldNotas = this.state.notas;
    this.toggleLoadModal();
    ApiHelper.getValoresUnitariosByDate(
      this.getTodayDateFormatted(),
      this.state.contratoID,
      (data, error) => {
        this.toggleLoadModal();
        if (error) {
          this.setState({
            httpError: error,
          });
        } else {
          var oldItensDeContratos = this.state.itens;
          oldItensDeContratos[oldNotas.length] = Util.mapItensDeContrato(data);
          this.setState(
            {
              itens: oldItensDeContratos,
            },
            () => {
              oldNotas.push({
                numero: "",
                data: "",
                itens: [
                  {
                    quantidade: "",
                    itemDeContrato: "",
                    observacao: "",
                    valor: "",
                    baixaValor: false,
                  },
                ],
                contratoID: this.state.contratoID,
              });
              this.setState(
                {
                  notas: oldNotas,
                },
                () => {
                  var refIndex = "nota" + (oldNotas.length - 1);
                  if (this.refs[refIndex]) {
                    this.refs[refIndex].scrollIntoView({ behavior: "smooth" });
                  }
                }
              );
            }
          );
        }
      }
    );
  }
  removeNota(notaKey) {
    var oldNotas = this.state.notas;
    oldNotas.splice(notaKey, 1);
    this.setState(
      {
        notas: oldNotas,
      },
      () => {
        var refIndex = "nota" + (oldNotas.length - 1);
        if (this.refs[refIndex]) {
          this.refs[refIndex].scrollIntoView({ behavior: "smooth" });
        }
        this.calculateValorTotal();
      }
    );
  }
  addItemNota(event, index) {
    event.preventDefault();
    var oldNotas = this.state.notas;
    var oldItens = oldNotas[index].itens;
    oldItens.push({
      quantidade: "",
      itemDeContrato: "",
      observacao: "",
      valor: "",
      baixaValor: false,
    });
    oldNotas[index].itens = oldItens;
    this.setState(
      {
        notas: oldNotas,
      },
      () => {
        var refIndex = "nota" + (oldNotas[index].itens.length - 1);
        if (this.refs[refIndex]) {
          this.refs[refIndex].scrollIntoView({ behavior: "smooth" });
        }
      }
    );
  }
  removeItemNota(index, itemIndex) {
    var oldNotas = this.state.notas;
    var oldItens = oldNotas[index].itens;

    oldItens.splice(itemIndex, 1);
    oldNotas[index].itens = oldItens;
    this.setState(
      {
        notas: oldNotas,
      },
      () => {
        var newMaxIndex = oldNotas[index].itens.length - 1;
        this.calculateItemValue(newMaxIndex, index);
        var refIndex = "nota" + newMaxIndex;
        if (this.refs[refIndex]) {
          this.refs[refIndex].scrollIntoView({ behavior: "smooth" });
        }
      }
    );
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors);
    var errorsValue = errorsJSON.erros;
    var errorsState = {};
    var notasError = [];
    var sumErros = {};
    this.state.itens.forEach((item) => {
      if (item.value !== null) {
        sumErros[item.value] = "";
      }
    });
    this.state.notas.forEach((nota) => {
      var itensError = [];
      nota.itens.forEach(() => {
        itensError.push({
          quantidade: "",
          itens_de_contrato_id: "",
          observacao: "",
        });
      });
      notasError.push({
        numero: "",
        valor: "",
        data: "",
        contrato_id: "",
        itens_nota_fiscal: itensError,
      });
    });
    for (var key in errorsValue) {
      if (key.includes("notas.")) {
        var index = key.split("notas.").join("");
        if (index.includes(".numero")) {
          index = index.split(".numero").join("");
          notasError[index].numero = errorsValue[key][0];
        }
        if (index.includes(".data")) {
          index = index.split(".data").join("");
          notasError[index].data = errorsValue[key][0];
        }
        if (index.includes(".contrato_id")) {
          index = index.split(".contrato_id").join("");
          notasError[index].contrato_id = errorsValue[key][0];
        }
        if (index.includes(".valor")) {
          index = index.split(".valor").join("");
          notasError[index].valor = errorsValue[key][0];
        }
        if (index.includes(".itens_nota_fiscal.")) {
          var stringSplitted = index.split(".itens_nota_fiscal.");
          var notaIndex = stringSplitted[0];
          var itemIndex = undefined;
          if (stringSplitted[1].includes(".quantidade")) {
            itemIndex = stringSplitted[1].split(".quantidade").join("");
            notasError[notaIndex].itens_nota_fiscal[itemIndex].quantidade =
              errorsValue[key][0];
          }
          if (stringSplitted[1].includes(".itens_de_contrato_id")) {
            itemIndex = stringSplitted[1]
              .split(".itens_de_contrato_id")
              .join("");
            notasError[notaIndex].itens_nota_fiscal[
              itemIndex
            ].itens_de_contrato_id = errorsValue[key][0];
          }
          if (stringSplitted[1].includes(".observacao")) {
            itemIndex = stringSplitted[1].split(".observacao").join("");
            notasError[notaIndex].itens_nota_fiscal[itemIndex].observacao =
              errorsValue[key][0];
          }
        }
      } else if (key.includes("sumItem")) {
        var indexSum = key.split("sumItem").join("");
        sumErros[indexSum] = errorsValue[key][0];
      } else {
        errorsState[key + "Error"] = errorsValue[key][0];
      }
    }
    errorsState.sumErros = sumErros;
    errorsState.notasError = notasError;
    this.setState(errorsState);
  }
  mapItensDeNota(itens, notaIndex) {
    var mappedItens = [];
    itens.forEach((item) => {
      var mappedItem = {
        quantidade: item.quantidade,
        itens_de_contrato_id: item.itemDeContrato,
        observacao: item.observacao,
        valor_unitario: this.getItemDeContratoValue(
          item.itemDeContrato,
          notaIndex
        ),
      };
      mappedItens.push(mappedItem);
    });
    return mappedItens;
  }
  calculateValorTotal() {
    var somaValoresNotas = 0;
    this.state.notas.forEach((nota) => {
      somaValoresNotas += nota.valor;
    });
    this.setState({
      valorTotal: somaValoresNotas,
    });
  }
  sendForm(event) {
    event.preventDefault();
    var notas = [];
    this.state.notas.forEach((nota, key) => {
      var mappedNota = {
        numero: nota.numero,
        valor: nota.valor,
        data: Util.dateOnly(nota.data),
        contrato_id: nota.contratoID,
        itens_nota_fiscal: this.mapItensDeNota(nota.itens, key),
      };
      notas.push(mappedNota);
    });
    var parameters = {
      valor_total: this.state.valorTotal,
      contrato_id: this.state.contratoID,
      notas: notas,
    };
    this.toggleLoadModal();
    ApiHelper.createNotas(parameters, (error) => {
      this.toggleLoadModal();
      if (error) {
        this.showErrorMessage();
        this.handleErrors(error);
      } else {
        this.showSucessMessage();
        Util.sleep(3000).then(() => {
          this.props.callBackGerenciar();
        });
      }
    });
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      );
    }
    return this.state.showForm ? (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <ToastContainer
          ref={(input) => {
            this.container = input;
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <div>
          <div className="card card-plain">
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">Adicionar Baixas do contrato</h4>
              <p className="category">
                Contrato:
                {this.state.objeto}
              </p>
            </div>
            <div className="card-content">
              <div className="card content">
                <div className="row">
                  <div className="col-md-4">
                    <h6>Saldo inicial do contrato:</h6>
                  </div>
                  <div className="col-md-12">
                    <strong>
                      {Util.formatCurrency(parseFloat(this.state.saldoInicial))}
                    </strong>
                  </div>
                  <div className="col-md-4">
                    <h6>Saldo contratual:</h6>
                  </div>
                  <div className="col-md-12">
                    <strong>
                      {Util.formatCurrency(
                        parseFloat(this.state.saldoContratual.toFixed(2))
                      )}
                    </strong>
                  </div>
                </div>
              </div>
              {this.state.notas.map((item, notaKey) => {
                return (
                  <div
                    ref={"nota" + notaKey}
                    key={notaKey}
                    className="card col-sm-12"
                    data-background-color="light-blue"
                  >
                    <div className="card card-content">
                      <div className="card card-item col-xl-12 col-lg-6 col-md-12 col-sm-12 col-6">
                        <InputCustom
                          onChange={(event) =>
                            this.onChangeNumeroNota(event, notaKey)
                          }
                          type="number"
                          sizeClass="col-lg-6 col-md-6 col-sm-6"
                          label={"Número da nota fiscal"}
                          error={
                            this.state.notasError[notaKey]
                              ? this.state.notasError[notaKey].numero
                              : ""
                          }
                          value={this.state.notas[notaKey].numero}
                        />
                        <InputCustom
                          onChange={(value) =>
                            this.onChangeDataNota(value, notaKey)
                          }
                          type="date"
                          sizeClass="col-lg-6 col-md-6 col-sm-6"
                          label={"Data da nota fiscal"}
                          error={
                            this.state.notasError[notaKey]
                              ? this.state.notasError[notaKey].data
                              : ""
                          }
                          value={this.state.notas[notaKey].data}
                        />
                      </div>
                      <div>
                        <h4 className="title col-xl-12 col-lg-12 col-md-12 col-sm-12 col-6">
                          Itens da nota
                        </h4>
                      </div>
                      {this.state.notas[notaKey].itens.map((itemNota, key) => {
                        return (
                          <div
                            key={key}
                            className="card card-content card-item"
                            style={{ width: "100%" }}
                          >
                            <div className="row"></div>
                            <div className="row">
                              <SelectCustom
                                error={
                                  (this.state.notasError[notaKey]
                                    ? this.state.notasError[notaKey]
                                        .itens_nota_fiscal[key]
                                      ? this.state.notasError[notaKey]
                                          .itens_nota_fiscal[key]
                                          .itens_de_contrato_id
                                      : undefined
                                    : undefined) ||
                                  ((
                                    this.state.sumErros
                                      ? this.state.sumErros[
                                          this.state.notas[notaKey].itens[key]
                                            .itemDeContrato
                                        ]
                                      : ""
                                  )
                                    ? this.state.sumErros
                                      ? this.state.sumErros[
                                          this.state.notas[notaKey].itens[key]
                                            .itemDeContrato
                                        ]
                                      : ""
                                    : "")
                                }
                                onChange={(event) =>
                                  this.onChangeItemDeContratoNota(
                                    event,
                                    key,
                                    notaKey
                                  )
                                }
                                options={this.state.itens[notaKey]}
                                sizeClass="col-md-12"
                                label="Item de contrato"
                                value={itemNota.itemDeContrato}
                              />
                            </div>
                            <div className="row">
                              <InputCustom
                                type="checkbox"
                                sizeClass="col-md-1"
                                checked={itemNota.baixaValor}
                                label="Valor"
                                onChange={(event) =>
                                  this.onChangeBaixaValor(event, key, notaKey)
                                }
                              />
                              {itemNota.baixaValor ? (
                                <InputDinheiroBR
                                  error={
                                    this.state.notasError[notaKey]
                                      ? this.state.notasError[notaKey]
                                          .itens_nota_fiscal[key]
                                        ? this.state.notasError[notaKey]
                                            .itens_nota_fiscal[key].valor
                                        : ""
                                      : ""
                                  }
                                  onChange={(valueFormatado, value) =>
                                    this.onChangeQuantidadeNota(
                                      { target: { value: value } },
                                      key,
                                      notaKey,
                                      value
                                    )
                                  }
                                  sizeClass="col-md-2"
                                  label="Valor"
                                  value={itemNota.valor}
                                />
                              ) : (
                                <InputCustom
                                  step="0.01"
                                  error={
                                    this.state.notasError[notaKey]
                                      ? this.state.notasError[notaKey]
                                          .itens_nota_fiscal[key]
                                        ? this.state.notasError[notaKey]
                                            .itens_nota_fiscal[key].quantidade
                                        : ""
                                      : ""
                                  }
                                  onChange={(event) =>
                                    this.onChangeQuantidadeNota(
                                      event,
                                      key,
                                      notaKey,
                                      undefined
                                    )
                                  }
                                  type="number"
                                  sizeClass="col-md-2"
                                  label="Quantidade"
                                  value={itemNota.quantidade}
                                />
                              )}
                              <InputCustom
                                onChange={(event) =>
                                  this.onChangeObservacaoNota(
                                    event,
                                    key,
                                    notaKey
                                  )
                                }
                                error={
                                  this.state.notasError[notaKey]
                                    ? this.state.notasError[notaKey]
                                        .itens_nota_fiscal[key]
                                      ? this.state.notasError[notaKey]
                                          .itens_nota_fiscal[key].observacao
                                      : ""
                                    : ""
                                }
                                type="text"
                                sizeClass="col-md-8"
                                label="Observação"
                                value={itemNota.observacao}
                              />
                            </div>

                            <div className="row text-center">
                              <span className="label label-rose label-large">
                                Valor total do item:
                                {this.maskMoney(
                                  this.state.notas[notaKey].itens[key].valor
                                )}
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={(event) =>
                                this.removeItemNota(notaKey, key)
                              }
                              className="btn btn-danger"
                              data-background-color="red"
                            >
                              <i className="icon-header material-icons">
                                delete
                              </i>
                            </button>
                          </div>
                        );
                      })}

                      <button
                        onClick={(event) => this.addItemNota(event, notaKey)}
                        className="btn btn-primary pull-right"
                        data-background-color="green"
                      >
                        <i className="icon-header material-icons">add</i>
                      </button>
                      <span className="label label-inverse label-large">
                        Valor total da nota:{" "}
                        {this.maskMoney(this.state.notas[notaKey].valor)}
                      </span>
                    </div>
                    <button
                      type="button"
                      onClick={(event) => this.removeNota(notaKey)}
                      className="btn btn-danger pull-left"
                      data-background-color="red"
                    >
                      <i className="icon-header material-icons">delete</i>
                    </button>
                  </div>
                );
              })}
              <div className="row">
                <span className="label label-inverse label-large">
                  Soma de todas as notas:{" "}
                  {Util.formatCurrency(this.state.valorTotal)}
                </span>
              </div>
              <div className="row">
                <span className="label label-inverse label-large">
                  Saldo após a baixa:{" "}
                  {Util.formatCurrency(
                    parseFloat(this.state.saldoContratual.toFixed(2)) -
                      parseFloat(this.state.valorTotal.toFixed(2))
                  )}
                </span>
              </div>
              <div className="row">
                <span className="label label-danger">
                  {this.state.valor_totalError}
                </span>
              </div>
            </div>
            <button
              onClick={this.addNota}
              className="btn btn-primary pull-left"
              data-background-color="green"
            >
              <i className="icon-header material-icons">add</i>
            </button>
            <div className="row">
              <button
                onClick={this.sendForm}
                type="submit"
                className="btn btn-primary pull-right"
                data-background-color="as-blue"
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <Loading />
    );
  }
}
export default withRouter(GerenciarForm);



// WEBPACK FOOTER //
// ./src/views/modais/GerenciarForm.js